import * as R from 'ramda'

import {FETCH_UNIVER_UI,
        UUI_GLOBAL,
        UUI_THEME,
       } from '../types'
  
const initialState = {};

export default function mainuniua(state = initialState, {type,payload}) {
    switch (type) {
        case FETCH_UNIVER_UI:
            return { ...state, ...payload }
        case UUI_GLOBAL:
            return { ...state, ...payload }
        case UUI_THEME:
            return { ...state, ...payload }
        default:
            return state;
    }
}